module.exports = __webpack_public_path__ + "static/media/06_tn.bd0750f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/06_tn.jpg
// module id = 220
// module chunks = 0